
angular.module('mtic.components.modules.qcModule',[]).component('qcModule', {
  templateUrl: 'template.html',
  bindings: {
    moduleMapData: '<'
  },
  controllerAs: 'qcModule',
  controller: function(EventManager, $scope) {
    var eventManager = new EventManager('qcModule', $scope);
    var qcModule = this;
    qcModule.openResource = function(resource) {
      eventManager.broadcast('module:open:resource', resource)
    }
  }
})
